import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { TitleAndSubtitleComponent } from '@shared/title-and-subtitle/title-and-subtitle';
import { pricingPlansItems } from '@content/pricing/pricing-plans/pricing-plans';
import { PricingPlansItem } from '@content/pricing/pricing-plans/pricing-plans.type';
import { FeaturesItemComponent } from '@shared/features-item/features-item.component';
import { PriceDropdownComponent } from '@content/pricing/pricing-plans/price-dropdown/price-dropdown.component';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { ButtonGroupComponent } from '@content/pricing/pricing-plans/button-group/button-group.component';
import { ArrowComponent } from '@shared/arrow/arrow.component';
import { featuresContent } from '@shared/features-content/features-content';
import { ButtonGroupItem } from '@content/pricing/pricing-plans/button-group/button-group.type';
import { FeaturesItem } from '@content/features/features-type';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-pricing-plans',
    imports: [
        ContentWrapperComponent,
        FeaturesItemComponent,
        PriceDropdownComponent,
        NgOptimizedImage,
        AssetPipe,
        ButtonGroupComponent,
        ArrowComponent,
        TitleAndSubtitleComponent,
        RouterLink,
    ],
    templateUrl: './pricing-plans.component.html',
    styleUrl: './pricing-plans.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingPlansComponent {
    public readonly pricingPlansItems: PricingPlansItem[] = pricingPlansItems;
    public readonly feature: FeaturesItem = featuresContent.at(-1) as FeaturesItem;
    public readonly monthlyButtons: ButtonGroupItem[] = [
        {
            title: $localize`:@@pricing-yearly-billing:Yearly billing`,
            specialOffer: $localize`:@@pricing-save-30:save 30%`,
        },
        { title: $localize`:@@pricing-monthly-billing:Monthly billing` },
    ];
}
